import { useQuery } from '@tanstack/react-query';
import { queryKey } from '../../../constant/queryKey';
import { useGoodsSno } from '../../../hooks/useGoodsSno';
import { aiStudioService } from 'shared/src/api';
import { useIsAnonymousUser } from 'shared/src/hooks';

export const useRepresentativeImagesRedirectPath = () => {
  const goodsSno = useGoodsSno();
  // const { data: me } = useMyInfo();

  const isAnonymouseUser = useIsAnonymousUser();
  return useQuery({
    enabled: !isAnonymouseUser,
    queryKey: queryKey.goodsRepresentativeImagesRedirectPath(goodsSno),
    queryFn: () =>
      aiStudioService.getRepresentativeImageRedirectPath({
        goods_sno: goodsSno,
      }),
  });
};
